import { ComputerOutlined, LocationOnOutlined } from '@mui/icons-material';

import { ThemaFromThemaRouter } from '../../../dtos.ts';
import { isOnlineAndOrPraesenz, onlineAndOrPraesenz } from '../../../utils/isOnline.ts';
import { Tag } from '../Tag.tsx';

export const getOnlinePraesenzTag = (
  thema: Pick<ThemaFromThemaRouter, 'isOnline' | 'strukturellesFormat' | 'module'>,
) => {
  const result = isOnlineAndOrPraesenz(thema.isOnline, thema.strukturellesFormat, thema.module);

  switch (result) {
    case onlineAndOrPraesenz.ONLINE:
      return (
        <Tag style="brandLight" size="default">
          <ComputerOutlined sx={{ fontSize: '16px' }} />
          Online
        </Tag>
      );
    case onlineAndOrPraesenz.PRAESENZ:
      return (
        <Tag style="brandLight" size="default">
          <LocationOnOutlined sx={{ fontSize: '16px' }} />
          Präsenz
        </Tag>
      );
    case onlineAndOrPraesenz.PRAESENZ_AND_ONLINE:
      return (
        <Tag style="brandLight" size="default">
          <LocationOnOutlined sx={{ fontSize: '16px' }} />
          Präsenz & Online
        </Tag>
      );
  }
};
